import React, { useState } from "react";
import { Text, TextInput, TouchableOpacity, View } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppFontStyle } from "../../styles/AppFontStyle";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { AppColors } from "../../utility/AppColors";
import DeviceWalkthrough from "../walk-through-common-components/createEventTooltips/DeviceWalkthrough";
import GamerIdWalkthrough from "../walk-through-common-components/createEventTooltips/GamerIdWalkthrough";

const DeviceAndGameIdComponent = ({
  device,
  setDevice,
  gamerID,
  setGamerID,
  isOpen,
  setIsOpen,
  setIsOpenDuration = (value) => {},
  setIsOpenQuality = (value) => {},
  scrollViewRef,
}) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();

  const handleConsoleClick = (console) => {
    setDevice(console);
    setIsOpen(false);
    setIsOpenDuration(false);
    setIsOpenQuality(false);
  };

  const handleParentClick = (parent) => {
    setOpenChild(openChild === parent ? null : parent);
  };

  const options = [
    { name: "PC" },
    { name: "XBOX", children: ["XBOX ONE", "X/S"] },
    { name: "Playstation", children: ["PS 4", "PS 5"] },
    { name: "Mobile" },
    { name: "CrossPlay", children: ["PC & Console", "Console Only"] },
  ];
  const [openChild, setOpenChild] = useState(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <View style={styles.mainInputWrapper}>
      <View style={styles.leftWrapper}>
        <DeviceWalkthrough scrollViewRef={scrollViewRef} />
        <View style={{ position: "relative", zIndex: 999 }}>
          <TouchableOpacity onPress={toggleDropdown}>
            <View style={styles.dropdownButtonStyle}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  styles.dropdownButtonTxtStyle,
                  {
                    color: AppColors.white,
                  },
                ]}
              >
                {device || "Select Console"}
              </Text>
              <Icon
                name={isOpen ? "chevron-up" : "chevron-down"}
                style={styles.dropdownButtonArrowStyle}
              />
            </View>
          </TouchableOpacity>

          {isOpen && (
            <View
              style={{
                position: "absolute",
                left: 0,
                width: "100%",
                top: 50,
                borderWidth: 1,
                borderColor: AppColors.white,
                marginTop: 2,
                backgroundColor: AppColors.black,
                zIndex: 1000,
                elevation: 10,
              }}
            >
              {options.map((option, idx) => (
                <View key={idx}>
                  <TouchableOpacity
                    style={{
                      padding: 2,
                      borderBottomColor: AppColors.white,
                      borderBottomWidth: 1,
                      cursor: "pointer",
                      flexDirection: "row",
                    }}
                    onPress={() =>
                      option.children
                        ? handleParentClick(option.name)
                        : handleConsoleClick(option.name)
                    }
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.gray_C3C3C3,
                          paddingVertical: 14,
                          textAlign: "center",
                          flex: 1,
                        },
                      ]}
                    >
                      {option.name}
                    </Text>
                    {option.children && (
                      <Icon
                        name={
                          openChild === option.name
                            ? "chevron-up"
                            : "chevron-down"
                        }
                        style={styles.dropdownButtonArrowStyle}
                      />
                    )}
                  </TouchableOpacity>

                  {/* Accordion for child options */}
                  {openChild === option.name &&
                    option.children?.map((child, childIdx) => (
                      <TouchableOpacity
                        key={childIdx}
                        style={{
                          paddingLeft: 10,
                          paddingHorizontal: 20,
                          cursor: "pointer",
                          backgroundColor: AppColors.black,
                          borderBottomColor: AppColors.white,
                          borderBottomWidth: 1,
                        }}
                        onPress={() => handleConsoleClick(child)}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.gray_C3C3C3,
                              paddingVertical: 14,
                              textAlign: "center",
                            },
                          ]}
                        >
                          {child}
                        </Text>
                      </TouchableOpacity>
                    ))}
                </View>
              ))}
            </View>
          )}
        </View>
      </View>
      <View
        style={[
          styles.leftWrapper,
          {
            position: "relative",
            zIndex: isOpen ? -1 : 100,
            elevation: 0,
          },
        ]}
      >
        <GamerIdWalkthrough />
        <View
          style={[
            styles.inputWrapper,
            {
              // zIndex: -1
            },
          ]}
        >
          <TextInput
            placeholder={"xxxxxxxx"}
            multiline={false}
            placeholderTextColor={AppColors.gray_C4C4C4}
            style={[AppFontStyle.REGULAR_ANYBODY_12, styles.textInputStyle]}
            // ref={refValue}
            onSubmitEditing={() => {}}
            onChange={(e) => {
              const value = e.nativeEvent.text;
              // setGamerID(value);
              setGamerID((prev) => ({ ...prev, organiser: value }));
            }}
            secureTextEntry={false}
            value={gamerID.organiser}
          />
        </View>
      </View>
    </View>
  );
};

export default DeviceAndGameIdComponent;

const useStyles = CreateResponsiveStyle(
  {
    mainInputWrapper: {
      flexDirection: "row",
      gap: 25,
    },
    leftWrapper: {
      flex: 0.5,
      flexDirection: "column",
      gap: 12,
    },
    dropdownButtonStyle: {
      width: "100%",
      height: 50,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      borderRadius: 12,
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      paddingHorizontal: 12,
    },
    dropdownButtonTxtStyle: {
      flex: 1,
      color: AppColors.white,
    },
    dropdownButtonArrowStyle: {
      fontSize: 28,
      color: AppColors.white,
    },
    inputWrapper: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      paddingHorizontal: 12,
      borderRadius: 10,
    },
    textInputStyle: {
      paddingVertical: 18,
      paddingHorizontal: 10,
      color: AppColors.white,
      outlineStyle: "none",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      mainInputWrapper: {
        flexDirection: "row",
        gap: 25,
      },
      leftWrapper: {
        flex: 0.5,
        flexDirection: "column",
        gap: 12,
      },
    },
    [DEVICE_SIZES.MD]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
    },
    [DEVICE_SIZES.SM]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
      inputWrapper: {
        flex: 1,
      },
    },

    [DEVICE_SIZES.XS]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
      inputWrapper: {
        flex: 1,
      },
    },
  }
);
